export const CLAIM_PAYOUT_STEPS = {
  loading: "loading",
  verify: "verify",
  paymentChoice: "paymentChoice",
  claimedCredit: "claimedCredit",
  paidOut: "paidOut",
  error: "error",
} as const;
